import { render, staticRenderFns } from "./GovBanner.vue?vue&type=template&id=0cec5fab&scoped=true"
import script from "./GovBanner.vue?vue&type=script&lang=js"
export * from "./GovBanner.vue?vue&type=script&lang=js"
import style0 from "./GovBanner.vue?vue&type=style&index=0&id=0cec5fab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cec5fab",
  null
  
)

export default component.exports